import React from 'react';

import { Title, Button, useMantineTheme, Group, TextInput, Tooltip, ActionIcon } from '@mantine/core';
import { IconPlus, IconFilterOff } from '@tabler/icons-react';

const UploadedFilesFilter = ({
  searchTerm,
  setSearchTerm,
  openCreateFiles,
  permission = true,
}: {
  searchTerm: string;
  setSearchTerm: (val: string) => void;
  openCreateFiles: () => void;
  permission: boolean;
}): JSX.Element => {
  const theme = useMantineTheme();
  return (
    <Group noWrap position='apart' p='xl' pb='xs'>
      <Title order={2} size='h2'>
        Uploaded Files
      </Title>

      <Group>
        <TextInput
          placeholder='Search a file by description'
          value={searchTerm}
          onChange={e => setSearchTerm(e.currentTarget.value)}
        />
        <Tooltip label='Clear filters'>
          <ActionIcon onClick={() => setSearchTerm('')}>
            <IconFilterOff />
          </ActionIcon>
        </Tooltip>
        <Button
          onClick={openCreateFiles}
          leftIcon={<IconPlus size={theme.fontSizes.md} />}
          disabled={!permission}
        >
          Upload a file
        </Button>
      </Group>
    </Group>
  );
};

export default UploadedFilesFilter;
